import createSagaMiddleware from "redux-saga";

import { carMiddlewares, carReducers } from "@b2bportal/core-cars";
import { hotelMiddlewares, hotelReducers } from "@b2bportal/core-hotels";
import { packagesReducers } from "@b2bportal/core-packages";
import {
  travelerReducers,
  travelerMiddlewares,
} from "@b2bportal/core-traveler";
import { tripsRootReducer } from "@b2bportal/core-trips";
import {
  walletOfferMiddlewares,
  walletOfferReducers,
} from "@b2bportal/core-wallet-offer";
import { authReducer } from "@hopper-b2b/self-serve";
import {
  combineSlices,
  configureStore,
  createDynamicMiddleware,
} from "@reduxjs/toolkit";
import { commerceTripsApi } from "@/pages/Trips/store/api";

export const dynamicMiddleware = createDynamicMiddleware();

const sagaMiddleware = createSagaMiddleware();
const middleware = [
  sagaMiddleware,
  ...hotelMiddlewares,
  ...walletOfferMiddlewares,
  ...carMiddlewares,
  ...travelerMiddlewares,
  commerceTripsApi.middleware,
];

export const reducer = combineSlices({
  auth: authReducer,
  trips: tripsRootReducer,
  ...hotelReducers,
  ...walletOfferReducers,
  ...packagesReducers,
  ...carReducers,
  ...travelerReducers,
  [commerceTripsApi.reducerPath]: commerceTripsApi.reducer,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(middleware)
      .concat(dynamicMiddleware.middleware),
});

// const rootSaga = {}
// // Run the root saga after creating the store
// sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
